/* DON'T EDIT THIS FILE: edit original and run build again */ import { frozenEmptyObject } from "../../../framework/core/frozen-empty-object.ts";
import Select, { components } from "react-select";

export const selectClassNames: any = {
  control: (state: any) =>
    "multi-select " + (state.isFocused ? "multi-select-focused" : ""),
  dropdownIndicator: (state: any) =>
    state.isFocused
      ? "multi-select-indicator-focused"
      : "multi-select-indicator",
  indicatorSeparator: () => "multi-select-indicator-separator",
  clearIndicator: () => "multi-select-clear",
  multiValue: () => "multi-select-multi-value",
  singleValue: () => "multi-select-single-value px-1",
  multiValueLabel: () => "multi-select-multi-value",
  multiValueRemove: () => "multi-select-value-remove",
  option: (state: any) =>
    state.isFocused
      ? "multi-select-option-focused"
      : state.isSelected
      ? "multi-select-option-selected"
      : "multi-select-option",
  menuList: () => "multi-select-menu-list",
  menuPortal: () => "multi-select-portal",
};

export const MultipleSelectInput = ({
  className = "",
  value,
  setValue,
  onChange,
  options,
  children = null,
  setChildrenInputValueForTests = (_param) => false,
  placeholder,
  menuPortalTarget,
  noOptionsMessage,
  menuShouldScrollIntoView,
  disabled,
  autoFocus,
}: {
  className?: string;
  value: any;
  setValue: any;
  onChange: any;
  options: { label: string; value: string }[];
  children?: React.ReactNode;
  setChildrenInputValueForTests?: (labelOrLabels: any) => boolean;
  placeholder?: string;
  menuPortalTarget?: HTMLElement;
  noOptionsMessage?: () => string;
  menuShouldScrollIntoView?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
}) => {
  const setRef = (node: HTMLSpanElement) => {
    if (node) {
      (
        node as HTMLSpanElement & { setInputValueForTests: any }
      ).setInputValueForTests = (labels: string[]) => {
        if (!setChildrenInputValueForTests(labels)) {
          const selected = options
            .filter(({ label }) => labels.includes(label))
            .map(({ value }) => value);
          setValue(selected);
        }
      };
    }
  };
  const MenuList = (props: any) => (
    <components.MenuList {...props}>
      {children}
      {props.children}
    </components.MenuList>
  );
  return (
    <span
      ref={setRef}
      data-is-input
      data-is-multiple-select
      className={className}
    >
      <Select
        isMulti={true}
        value={value}
        onChange={onChange}
        options={options}
        classNames={selectClassNames}
        components={
          disabled
            ? { DropdownIndicator: () => null, IndicatorSeparator: () => null }
            : children
            ? { MenuList }
            : frozenEmptyObject
        }
        placeholder={placeholder}
        menuPortalTarget={menuPortalTarget}
        noOptionsMessage={noOptionsMessage}
        menuShouldScrollIntoView={menuShouldScrollIntoView}
        isDisabled={disabled}
        autoFocus={autoFocus}
      />
    </span>
  );
};
